import CheckEmail from './container';

export default CheckEmail;



// WEBPACK FOOTER //
// ./src/views/Auth/CheckEmail/index.js